// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.line1
{
  width:43.64px;
  border: 1.5px solid #212121;

  margin-right: 0px;
}

.line2
{
  width:57.42px;
  border: 1.5px solid #212121;
  margin-top: 13.06px;
  margin-right: 0px;
}
.line3
{
  width:43.64px;
  border: 1.5px solid #212121;
  margin-right: 0px;

}
.lines-box
{
  display: inline-block;
  align-items: right;
  width:72px;
  height: 72px;
  margin-right: 6px;
  margin-top: -6.75px;
  text-align: right;
}

.auto-lines
{
  display: flex
}
.mecherleh3
{
color:#212121;
font-family: "MecherleSans-SemiBold";
font-size: 22px;
font-weight: 600;
line-height: 22px;
letter-spacing: 0em;
text-align: center;
margin-top: 2.5px;
margin-bottom: 2.5px;
}
.mecherlebody2
{
  font-family: "MecherleSans";
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: center;
  color:#767676
}

.mecherleh6
{
  font-family: "MecherleSans";
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  display: flex;
  flex-direction: column;
  gap: 32px;
  text-align: center;
  margin-top: 4vh;
  margin-bottom: 4vh;
  }

.say-goodbye-box
{
  font-family: "MecherleSans";
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  height: 32px;
  display: flex;
  margin-top: 4vh;
  margin-bottom: 4vh;
  margin-left: 5vw;
  margin-right:5vw;
  text-align: center;
  justify-content: center;

}
.mecherlebody
{
  left: 15px;
  color:#212121;

  font-family: "MecherleSans";
  font-size: 16px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: center;
  margin-bottom:0px;

}

.group12
{
  height: 47px;
  padding-left: 15px;
  padding-right: 15px;
  margin-top: 4vh;
  margin-bottom: 4vh;
}

.mecherlelist li {
  font-family: "MecherleSans";
  font-size: 16px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: -0.2em;
  text-align: left;
}


#laterQuick
{
  width: 176px;
}
#continueQuick
{
  width: auto;
}
.frame32
{
  margin-top: 3px;
  height:43px;
}

.mecherle-list-box
{
  margin-left: 5vw;
  margin-right:5vw;
  padding-top: 15px;
  display: flex;
  justify-content: center;
}

.mecherle-big-box
{
  justify-content: center;
  padding-left: 15px;
  padding-right: 15px;
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 4vh;
  margin-bottom: 4vh;
}

`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/confirmation/received-autoAB/received-auto-ab/received-auto-ab.component.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa;EACb,2BAA2B;;EAE3B,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,aAAa;EACb,2BAA2B;EAC3B,iBAAiB;;AAEnB;AACA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE;AACF;AACA;;AAEA,aAAa;AACb,oCAAoC;AACpC,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,mBAAmB;AACnB,kBAAkB;AAClB,iBAAiB;AACjB,oBAAoB;AACpB;AACA;;EAEE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB;AACF;;AAEA;;EAEE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB;;AAEF;;EAEE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;;AAEzB;AACA;;EAEE,UAAU;EACV,aAAa;;EAEb,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;;AAEnB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;;AAGA;;EAEE,YAAY;AACd;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".line1\n{\n  width:43.64px;\n  border: 1.5px solid #212121;\n\n  margin-right: 0px;\n}\n\n.line2\n{\n  width:57.42px;\n  border: 1.5px solid #212121;\n  margin-top: 13.06px;\n  margin-right: 0px;\n}\n.line3\n{\n  width:43.64px;\n  border: 1.5px solid #212121;\n  margin-right: 0px;\n\n}\n.lines-box\n{\n  display: inline-block;\n  align-items: right;\n  width:72px;\n  height: 72px;\n  margin-right: 6px;\n  margin-top: -6.75px;\n  text-align: right;\n}\n\n.auto-lines\n{\n  display: flex\n}\n.mecherleh3\n{\ncolor:#212121;\nfont-family: \"MecherleSans-SemiBold\";\nfont-size: 22px;\nfont-weight: 600;\nline-height: 22px;\nletter-spacing: 0em;\ntext-align: center;\nmargin-top: 2.5px;\nmargin-bottom: 2.5px;\n}\n.mecherlebody2\n{\n  font-family: \"MecherleSans\";\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  letter-spacing: 0em;\n  text-align: center;\n  color:#767676\n}\n\n.mecherleh6\n{\n  font-family: \"MecherleSans\";\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 16px;\n  letter-spacing: 0em;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  text-align: center;\n  margin-top: 4vh;\n  margin-bottom: 4vh;\n  }\n\n.say-goodbye-box\n{\n  font-family: \"MecherleSans\";\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 16px;\n  height: 32px;\n  display: flex;\n  margin-top: 4vh;\n  margin-bottom: 4vh;\n  margin-left: 5vw;\n  margin-right:5vw;\n  text-align: center;\n  justify-content: center;\n\n}\n.mecherlebody\n{\n  left: 15px;\n  color:#212121;\n\n  font-family: \"MecherleSans\";\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 21px;\n  letter-spacing: 0em;\n  text-align: center;\n  margin-bottom:0px;\n\n}\n\n.group12\n{\n  height: 47px;\n  padding-left: 15px;\n  padding-right: 15px;\n  margin-top: 4vh;\n  margin-bottom: 4vh;\n}\n\n.mecherlelist li {\n  font-family: \"MecherleSans\";\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 21px;\n  letter-spacing: -0.2em;\n  text-align: left;\n}\n\n\n#laterQuick\n{\n  width: 176px;\n}\n#continueQuick\n{\n  width: auto;\n}\n.frame32\n{\n  margin-top: 3px;\n  height:43px;\n}\n\n.mecherle-list-box\n{\n  margin-left: 5vw;\n  margin-right:5vw;\n  padding-top: 15px;\n  display: flex;\n  justify-content: center;\n}\n\n.mecherle-big-box\n{\n  justify-content: center;\n  padding-left: 15px;\n  padding-right: 15px;\n  margin-left: 15px;\n  margin-right: 15px;\n  margin-top: 4vh;\n  margin-bottom: 4vh;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
